/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./node_modules/isinview/dist/index.es.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var defaultOptions = {
    once: false,
    threshold: 0,
};
var buildOptions = function (options) {
    return __assign(__assign({}, defaultOptions), options);
};
var observe = function (target, observer) {
    var targets = target instanceof Element ? [target] : target;
    for (var i = 0; i < targets.length; i++) {
        observer.observe(targets[i]);
    }
};
var createObserver = function (callback, options, condition) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var target = entry.target;
            if (entry.rootBounds !== null && condition(entry)) {
                callback(target, {
                    isAboveView: entry.boundingClientRect.bottom < entry.rootBounds.height / 2 && entry.boundingClientRect.top < 0,
                    isInView: entry.isIntersecting,
                    isBelowView: entry.boundingClientRect.top > entry.rootBounds.height / 2 && entry.boundingClientRect.bottom > entry.rootBounds.height,
                });
                if (options.once) {
                    observer.unobserve(target);
                }
            }
        });
    }, {
        threshold: options.threshold,
    });
    return observer;
};
function isSupported() {
    return 'IntersectionObserver' in window;
}
var isInView = function (target, callback, options) {
    if (options === void 0) { options = {}; }
    var completeOptions = buildOptions(options);
    var observer = createObserver(callback, completeOptions, function (entry) { return entry.isIntersecting; });
    observe(target, observer);
};
var isOutOfView = function (target, callback, options) {
    if (options === void 0) { options = {}; }
    var completeOptions = buildOptions(options);
    var observer = createObserver(callback, completeOptions, function (entry) { return !entry.isIntersecting; });
    observe(target, observer);
};


//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./src/js/packages/video-object.js


if (!customElements.get('video-object')) {
  class VideoObject extends HTMLElement {
    constructor() {
      super();

      this.mediaId = this.dataset.mediaId;
      if (!this.mediaId) return;

      this.mediaType = this.dataset.mediaType;
      this.loaded = JSON.parse(this.dataset.loaded);

      this.bindEvents();
    }

    bindEvents() {
      this.coverButton = this.querySelector('.video__cover-button');

      this.coverButton.addEventListener('click', (event) => {
        this.pauseAllMedia();
        if (!this.loaded) {
          const content = document.createElement('div');
          content.appendChild(
            this.querySelector('template').content.firstElementChild.cloneNode(
              true
            )
          );

          this.loaded = true;
          this.dataset.loaded = true;
          this.appendChild(
            content.querySelector('video, model-viewer, iframe')
          ).focus();

          this.video = this.querySelector('video, model-viewer, iframe');
        }

        if (this.mediaType === 'youtube') this.loadYouTubeAPI();

        isOutOfView(this, (target) => {
          this.pauseMedia();
        });

        event.preventDefault();
      });

      
    }
 
    loadYouTubeAPI() {
      if (window.YT !== undefined) {
        theme.youTubeApiStatus = 'ready';
      }
      if (
        theme.youTubeApiStatus !== 'loaded' ||
        theme.youTubeApiStatus !== 'ready'
      ) {
        const script = document.createElement('script');
        script.id = `youtube-iframe-api`;
        script.src = `https://www.youtube.com/iframe_api`;
        script.async = true;
        script.onload = () => {
          theme.youTubeApiStatus = 'loaded';
        };
        document.body.append(script);
      }
      if (theme.youTubeApiStatus === 'ready') {
        this.player = new YT.Player(this.video.id, {
          events: {
            onReady: () => this.onPlayerReady(),
          },
        });
      } else {
        window.onYouTubeIframeAPIReady = () => {
          this.player = new YT.Player(this.video.id, {
            events: {
              onReady: () => {
                this.onPlayerReady();
                theme.youTubeApiStatus = 'ready';
              },
            },
          });
        };
      }
    }

    onPlayerReady(player) {
      this.player.playVideo();
      isOutOfView(this, (target) => {
        this.player.pauseVideo();
      });
    }

    pauseMedia() {
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
          '*'
        );
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
      this.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

    pauseAllMedia() {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
          '*'
        );
      });
      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

  }
  customElements.define('video-object', VideoObject);
}

/******/ })()
;